import React from "react";
import Header from "components/user/Header";
import Footer from "components/user/Footer";
import BeritaPopuler from "components/user/BeritaPopuler";
import CardPengumuman from "components/user/pengumuman/CardPengumuman";

function Pengumuman() {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Header */}
      <Header />

      {/* Main Content */}
      <main className="flex-grow">
        <div className="row mt-10 flex flex-wrap gap-6 p-5 mt-[75px]">
          <div className="w-full lg:w-[68%]">
            <CardPengumuman />
          </div>

          <div className="w-full lg:ml-auto lg:w-[30%]">
            <BeritaPopuler />
          </div>
        </div>
      </main>

      {/* Footer */}
      <Footer className="mt-auto" />
    </div>
  );
}

export default Pengumuman;
